import LitSearchPanel from './LitSearchPanel.svelte.js';
import LitJewelleryDetail from './LitJewelleryDetail.svelte.js';
import LitJewelleryOptions from './LitJewelleryOptions.svelte.js';

import { defaultParams } from './stores/storeInputOptions.js';
import { searchResult } from './stores/storeSearchResult.js';

let app;

const SearchPanel =
	document.querySelector('section#lit-search-panel-page') ?? false;

const JewelleryDetail = SearchPanel
	? false
	: document.querySelector('section#lit-jewellery-detail') ?? false;

const JewelleryOptions = JewelleryDetail
	? false
	: document.querySelector('section#lit-jewellery-options') ?? false;

if (SearchPanel) {
	let ds = SearchPanel.dataset ?? {};

	if (
		ds.search &&
		ds.excerpt &&
		ds.partslist &&
		ds.labellist &&
		ds.contents &&
		ds.banner &&
		ds.primarynavi &&
		ds.secondarynavi
	) {
		defaultParams.set({
			search: JSON.parse(ds.search),
			excerpt: JSON.parse(ds.excerpt),
			partslist: JSON.parse(ds.partslist),
			labellist: JSON.parse(ds.labellist),
			excerptlist: ds.firstexcerpts ? JSON.parse(ds.firstexcerpts) : false
		});

		if ( ds.firstresponse ) {
			searchResult.set(JSON.parse(ds.firstresponse));
		}

		app = new LitSearchPanel({
			target: SearchPanel,
			props: {
				contents: JSON.parse(ds.contents),
				banner: JSON.parse(ds.banner),
				primarynavi: JSON.parse(ds.primarynavi),
				secondarynavi: JSON.parse(ds.secondarynavi)
			}
		});
	}
} else if (JewelleryDetail) {
	app = new LitJewelleryDetail({
		target: JewelleryDetail,
		props: {
			jewellery: JSON.parse(JewelleryDetail.dataset.jewellery)
		}
	});
} else if (JewelleryOptions) {
	app = new LitJewelleryOptions({
		target: JewelleryOptions,
		props: {
			design: JSON.parse(JewelleryOptions.dataset.design ?? '{}'),
			types: JSON.parse(JewelleryOptions.dataset.types ?? '{}'),
			parts: JSON.parse(JewelleryOptions.dataset.parts ?? '{}'),
			viewType: JewelleryOptions.dataset.viewType
		}
	});
}

export default app;
